import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Small } from 'foundations-components/transitional/components/Small';
import { Fragment } from 'react';
import CompatibilityIcon from './CompatibilityIcon';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PlanCompatibilityMessage({
  appContext,
  compatibilityType,
  helpText,
  onCompatibilityModalOpen
}) {
  const {
    previewListingId
  } = useDetailsPageContext();
  const isPreview = previewListingId !== undefined;
  if (appContext === 'public' || isPreview) {
    return /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: () => onCompatibilityModalOpen(),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.compatibility.plans.compatibilityPopover.button"
      })
    });
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MediaObject, {
      align: "center",
      itemLeft: /*#__PURE__*/_jsx(CompatibilityIcon, {
        compatibilityType: compatibilityType
      }),
      spacing: "extra-small",
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "100",
        "data-test-id": "plan-compatibility-message",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: `detailsPage.compatibility.plans.compatibilityDescription.${compatibilityType}`
        }), helpText]
      })
    }), /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: () => onCompatibilityModalOpen(),
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.compatibility.plans.compatibilityPopover.button"
        })
      })
    })]
  });
}